// extracted by mini-css-extract-plugin
export default {"inner_canvas":"PageCampaignBuilder_inner_canvas__jfU+B"};